import React, { Fragment } from 'react';
import Bone from '@lightspeed/cirrus-bone';
import { Divider } from '@lightspeed/flame/Divider';

const ReceiptSaleLinesPlaceholder = () => (
  <Fragment>
    {Array(3)
      .fill()
      .map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={index >= 2 ? ' cr-hidden-md-down' : ''}>
          <div className="cr-flex cr-justify-between cr-pv-1">
            <div className="cr-width-8-12">
              <Bone width="35%" height="0.75rem" animated={false} />
            </div>

            <div className="cr-flex cr-justify-end cr-width-3-12">
              <span className="cr-width-3-12">
                <Bone height="0.75rem" animated={false} />
              </span>
              <span className="cr-pl-1 cr-width-9-12">
                <Bone height="0.75rem" animated={false} />
              </span>
            </div>
          </div>
          <Divider />
        </div>
      ))}

    <div className="cr-flex cr-justify-between cr-pv-2">
      <div className="cr-width-8-12">
        <Bone width="35%" height="0.75rem" animated={false} />
      </div>

      <div className="cr-width-3-12">
        <div className="cr-flex cr-pb-1">
          <span className="cr-width-3-12">
            <Bone height="0.75rem" animated={false} />
          </span>
          <span className="cr-pl-1 cr-width-9-12">
            <Bone height="0.75rem" animated={false} />
          </span>
        </div>

        <div className="cr-flex cr-pb-1 cr-justify-end">
          <div className="cr-pl-1 cr-width-9-12">
            <Bone height="0.75rem" animated={false} />
          </div>
        </div>

        <div className="cr-flex cr-justify-end cr-hidden-md-down">
          <div className="cr-pl-1 cr-pl-1 cr-width-9-12">
            <Bone height="0.75rem" animated={false} />
          </div>
        </div>
      </div>
    </div>
  </Fragment>
);

export default ReceiptSaleLinesPlaceholder;
